import React from 'react'
import { Radio } from 'components'
import {
  Body,
  LabelSection,
  MainContainer,
  SuggestionContainer,
  SuggestionContent,
  SuggestionHandler,
} from './BlendSelectableCard.styled'

type BlendSelectableCardTypes = {
  children?: React.ReactNode
  footer?: React.ReactNode
  selected: boolean
  onClick?: () => void
}

export const BlendSelectableCard = ({
  children,
  footer,
  selected,
  onClick,
}: BlendSelectableCardTypes) => {
  return (
    <Body>
      <SuggestionContainer>
        <SuggestionHandler>
          <Radio checked={selected} onClick={onClick} />
        </SuggestionHandler>
        <SuggestionContent>
          <MainContainer>{children}</MainContainer>
          <LabelSection>{footer}</LabelSection>
        </SuggestionContent>
      </SuggestionContainer>
    </Body>
  )
}
